import type { ReportImpiantoDTO } from '@/models/dto/report/report-impianto-dto'
import type { FacilityReport } from '@/models/types/report/facility-report'

const mapToFacilityReport = (dto: ReportImpiantoDTO): FacilityReport => {
    return {
        id: dto.id,
        requestDate: dto.dataRichiesta,
        creationDate: dto.dataCreazione,
        type: dto.tipologia,
        path: dto.path ?? undefined,
        reportUrl: dto.urlReport ?? undefined,
        status: dto.stato,
        facilityId: dto.idImpianto ?? undefined,
        facilityName: dto.nomeImpianto ?? undefined,
        iconUrl: dto.iconUrl ?? undefined,
    }
}

const mapToReportImpiantoDTO = (report: FacilityReport): ReportImpiantoDTO => {
    return {
        id: report.id,
        dataRichiesta: report.requestDate,
        dataCreazione: report.creationDate,
        tipologia: report.type,
        path: report.path ?? null,
        urlReport: report.reportUrl ?? null,
        stato: report.status,
        idImpianto: report.facilityId ?? null,
        nomeImpianto: report.facilityName ?? null,
        iconUrl: report.iconUrl ?? null,
    }
}

export { mapToFacilityReport, mapToReportImpiantoDTO }
